export const UPDATE_PROPS = '{memberships}UPDATE_PROPS';
export const DELETE_ORGANIZATION_IN_PROFILE = '{memberships}DELETE_ORGANIZATION_IN_PROFILE';
export const EDIT_PROFILE_BADGE_STARTING = '{memberships}EDIT_PROFILE_BADGE_STARTING';
export const EDIT_PROFILE_BADGE_FINISHED = '{memberships}EDIT_PROFILE_BADGE_FINISHED';
export const GETTING_BADGES_STARTED = '{memberships}GETTING_BADGES_STARTED';
export const GOT_BADGES = '{memberships}GOT_BADGES';



// WEBPACK FOOTER //
// ./src/app/stores/profile/memberships/constants.js